import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState } from "react";
import dompurify from "isomorphic-dompurify";
import { Button } from "@jti/ui/components/Button";
import styles from "../ConsentBlock.module.scss";
const { sanitize } = dompurify;
export const ConsentBenefitsList = ({ shortHtml, longHtml, showLessBenefitsButtonLabel, showMoreBenefitsButtonLabel, }) => {
    const listContainerId = useId();
    const [isCollapsed, setIsCollapsed] = useState(true);
    const isButtonVisible = !!longHtml;
    const innerHtml = isCollapsed ? shortHtml : longHtml;
    const ctaLabel = isCollapsed ? showMoreBenefitsButtonLabel : showLessBenefitsButtonLabel;
    const handleClick = () => {
        setIsCollapsed((prev) => !prev);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { id: listContainerId, className: styles.benefitsListWrapper, dangerouslySetInnerHTML: { __html: sanitize(innerHtml ?? "") } }), isButtonVisible && (_jsx(Button, { onClick: handleClick, variant: "cta", color: "tertiary", title: ctaLabel, className: styles.listCta, "aria-expanded": !isCollapsed, "aria-controls": listContainerId, children: ctaLabel }))] }));
};
//# sourceMappingURL=ConsentBenefitsList.js.map